export default "/images/vendor/flag-icon-css/flags/1x1/gh.svg?26d188e88a801ef36f645665f0eb8f33";